import { render, staticRenderFns } from "./platInfo.vue?vue&type=template&id=c49b858e&scoped=true&"
import script from "./platInfo.vue?vue&type=script&lang=js&"
export * from "./platInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49b858e",
  null
  
)

export default component.exports